import useQuery from "@/hooks/useQuery";
import { MARKET_PRICE_URL } from "@/common/constants";
import styled from "styled-components";
import { DataWrapper } from "@/common/components/dataWrapper";
import { FaNairaSign } from "react-icons/fa6";

const MarketPriceWrapper = styled.div`
    width: 100%,
    font-size: 14px;

    .price-error{
        color: red;
        font-size: 12px;
    }

    .price-container{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .price-list{
        width: 50%;
    }

    .price-label{
        margin: 5px 0px
    }

    .price-value{
        margin: 8px 0px;
        font-size: 0.8rem;
        display: flex;
        align-items: start;
        justify-content: space-between;
        gap: 3px;
    }

    .range{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: space-between;
        }
        
    .range p{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .range p:nth-child(2){
        color: gray;
    }
    
    .price-data{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: space-between;
    }

    .price-data p{
        display: flex;
        align-items: center;
        justify-content: space-between;
        }
        
        .price-data p:nth-child(2){
            color: gray;
        }
    
`;

const MarketPrice = () => {
  const {
    data: prices,
    loading: priceLoading,
    error: priceError,
  } = useQuery(MARKET_PRICE_URL);

  return (
    <MarketPriceWrapper>
      <DataWrapper
        noDataMessage="No market price to display"
        loading={priceLoading}
        error={priceError}
        loadingMessage="Unable to load market prices"
      >
        <div className="price-container">
          <div className="price-list">
            <p className="price-label">Cold storage</p>
            <div className="price-value">
              <div className="range">
                <p>Min</p>
                <p>
                  <FaNairaSign />
                  {prices?.cold?.min_price}
                </p>
              </div>
              <div className="price-data">
                <p>Max</p>
                <p>
                  <FaNairaSign />
                  {prices?.cold?.max_price}
                </p>
              </div>
            </div>
          </div>
          <div className="price-list">
            <p className="price-label">Non Cold storage</p>
            <div className="price-value">
              <div className="range">
                <p>Min</p>
                <p>
                  <FaNairaSign />
                  {prices?.non_cold?.min_price}
                </p>
              </div>
              <div className="price-data">
                <p>Max</p>
                <p>
                  <FaNairaSign />
                  {prices?.non_cold?.max_price}
                </p>
              </div>
            </div>
          </div>
        </div>
      </DataWrapper>
    </MarketPriceWrapper>
  );
};

export default MarketPrice;
